// import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
// import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
// import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useInvalidate, useLogout, useNavigation } from "@refinedev/core";
import { RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";
import React from "react"; //
// import { ColorModeContext } from "../../contexts/color-mode";
import GoogleLogin from "../GoogleLogin";
import { Button, IconButton } from "@mui/material";
import { LogoutOutlined, Storage, Build, Settings } from "@mui/icons-material";
import { useAuthStore } from "../../authProvider";
import EmergencyMessage from "../editor/emergency";
import logo from "../../assets/logo_transparent_white.png";
import { Link } from "react-router-dom";

export const Header: React.FC<RefineThemedLayoutV2HeaderProps> = ({
  sticky = true,
}) => {
  const { user } = useAuthStore();

  const invalidate = useInvalidate();

  const { mutate: logout } = useLogout();

  // Navigation hook to handle redirections
  const { push } = useNavigation();

  return (
    <AppBar
      sx={{
        backgroundColor: "#191919",
        height: "64px",
      }}
      position={sticky ? "sticky" : "relative"}
    >
      <Toolbar>
        <Stack
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Navigation links on the left side */}
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <Button
              color="inherit"
              onClick={() => push("/")}
              sx={{ textTransform: "none" }}
            >
              <img
                src={logo}
                alt="Fashion Words Logo"
                style={{
                  maxWidth: "100px",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Button>

            <Button
              color="inherit"
              startIcon={<Storage />}
              onClick={() => push("/brands")}
              sx={{ textTransform: "none" }}
            >
              Brands
            </Button>

            {!user?.isClientRelated && (user?.isAdmin || user?.isManager) ? (
              <Button
                color="inherit"
                startIcon={<Settings />}
                onClick={() => push("/admin/authorization")}
                sx={{ textTransform: "none" }}
              >
                Settings
              </Button>
            ) : (
              <></>
            )}

            {!user?.isClientRelated && (user?.isAdmin || user?.isManager) ? (
              <Button
                color="inherit"
                startIcon={<Build />}
                onClick={() => push("/admin/phrasebook-editor")}
                sx={{ textTransform: "none" }}
              >
                Phrasebook Editor
              </Button>
            ) : (
              <></>
            )}
          </Stack>

          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            {!user?.isClientRelated && (
              <EmergencyMessage
                buttonText="Talk to us"
                buttonColor="success"
                dialogTitle="Talk to us"
              />
            )}

            {!user?.isClientRelated && (user?.isAdmin || user?.isManager) ? (
              <GoogleLogin />
            ) : (
              <></>
            )}

            <Link
              to="/profile"
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              {user?.name && (
                <Stack
                  direction="row"
                  gap="1rem"
                  alignItems="center"
                  justifyContent="center"
                >
                  {user?.name && (
                    <Typography
                      sx={{
                        display: {
                          xs: "none",
                          sm: "inline-block",
                        },
                      }}
                      variant="subtitle2"
                    >
                      {user?.name}
                    </Typography>
                  )}
                  <Avatar alt={user?.name} />
                </Stack>
              )}
            </Link>

            <IconButton
              color="inherit"
              onClick={() => {
                invalidate({
                  resource: "*",
                  invalidates: ["all", "resourceAll"],
                });

                logout();
              }}
            >
              <LogoutOutlined />
            </IconButton>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
